import { Timer, Flame, Footprints, Award, CheckCircle2, BookOpen } from "lucide-react";
import { EVENTS } from "@/lib/reg";

const ICONS = { "100m": Timer, "800m": Flame, long_jump: Footprints, traditional: Award };
const LIB_IMG = "https://images.unsplash.com/photo-1692269725827-699e04a11cdf?crop=entropy&cs=srgb&fm=jpg&q=80&w=900";

const ELIG = [
  ["केवल लड़के", "Boys only"],
  ["आयु 15–18 वर्ष", "Age 15 to 18 years"],
  ["कक्षा 9वीं–12वीं", "Classes 9th to 12th"],
];

export const InfoSection = () => (
  <section className="gp-container py-10 sm:py-14 space-y-6" data-testid="event-details-bento">
    <div>
      <p className="eyebrow">प्रतियोगिताएँ · Sports Events</p>
      <div className="mt-3 grid grid-cols-2 md:grid-cols-4 gap-3">
        {EVENTS.map((e, i) => {
          const Icon = ICONS[e.id];
          return (
            <div key={e.id} className={`event-card c${i % 3}`} data-testid={`event-chip-${e.id}`}>
              <Icon size={26} />
              <div className="mt-3 font-hi font-bold text-navy">{e.hi}</div>
              <div className="text-xs text-slate-500">{e.en}</div>
            </div>
          );
        })}
      </div>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
      <div className="card md:col-span-2" data-testid="eligibility-card">
        <p className="eyebrow">पात्रता · Eligibility</p>
        <ul className="mt-4 space-y-3">
          {ELIG.map(([hi, en]) => (
            <li key={en} className="flex items-start gap-3">
              <CheckCircle2 className="text-green-700 mt-0.5 shrink-0" size={20} />
              <div>
                <div className="font-hi font-semibold text-navy">{hi}</div>
                <div className="text-xs text-slate-500">{en}</div>
              </div>
            </li>
          ))}
        </ul>
      </div>

      <div className="card mission md:col-span-3 overflow-hidden p-0" data-testid="mission-card">
        <img src={LIB_IMG} alt="Students reading books" className="h-40 w-full object-cover" />
        <div className="p-5 sm:p-6">
          <div className="flex items-center gap-2 text-green-800">
            <BookOpen size={18} /> <span className="eyebrow !text-green-800">Grampathshala</span>
          </div>
          <h3 className="mt-2 text-lg sm:text-xl font-bold text-navy">Free Library Movement Across India</h3>
          <p className="mt-2 font-hi text-slate-700">एक संकल्प, एक संदेश — भारत बने पुस्तकालयों का देश!</p>
          <p className="mt-2 text-sm text-slate-500">
            खेल से तन मज़बूत, किताबों से मन। Strong bodies through sport, strong minds through books.
          </p>
        </div>
      </div>
    </div>
  </section>
);
